module.exports = __webpack_public_path__ + "img/BWY-804.353acca7.jpg";